<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
        data: function () {
            return {
                Loader: null,
                currentYear: 0 // 全局年份
            };
        },
        methods: {
            Loading: function (msg) {
                var that = this;
                that.Loader = this.$loading({
                    lock: true,
                    text: msg,
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                    customClass: 'yt-loading2'
                });
            },
            LoadingCompleted: function () {
                var that = this;
                if (that.Loader) {
                    that.Loader.close();
                    that.Loader = null;
                }
            },
            getCurrentYear: function () {
                return this.currentYear;
            },
            setCurrentYear: function (year) {
                this.currentYear = year;
                // 通过事件总线通知所有组件
                this.$bus.$emit('year-changed', year);
            }
        },
        provide: function () {
            // 向下提供数据和方法
            return {
                // 加载
                Loading: this.Loading,
                LoadingCompleted: this.LoadingCompleted,
                // 年份管理
                getCurrentYear: this.getCurrentYear,
                setCurrentYear: this.setCurrentYear
            }
        },
        mounted() {
            // 监听全局年份变化事件
            this.$root.$on('global-year-change', (year) => {
                this.currentYear = year;
            });
        }
    };
</script>

<style>
    .yt-loading2 .el-loading-spinner {
        font-size: 50px;
    }

    .yt-loading2 .el-loading-spinner i {
        color: white !important;
    }

    .yt-loading2 .el-loading-text {
        font-size: 30px;
        color: white;
    }

    /* 全局滚动条样式 */
    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
</style>
